module.exports = __webpack_public_path__ + "img/my.c7a5c7c5.svg";